import { useTranslation } from 'react-i18next'
import { KebabCase } from 'type-fest'

import { NotPurchasedSection } from 'components/Section/NotPurchasedSection'
import { Tab } from 'components/Tabs'
import { Workspace } from 'features/workspace'
import { useAbility } from 'providers/casl'
import { PrebidStackTab } from './PrebidStack/PrebidStackTab'
import { RichPlacements } from './RichPlacements/RichPlacements'

export type DefaultsTab = KebabCase<'prebid-stack' | 'rich-placements'>

export type DefaultsUrlParams = Partial<{
  tab: DefaultsTab
  workspaceId: Workspace['id']
}>

export const useTabs = (): Tab<DefaultsTab>[] => {
  const { t: tProduct } = useTranslation('features/product')

  const ability = useAbility()

  const noAccessToPrebid: boolean =
    ability.cannot('access', 'Product-prebidStack') ||
    ability.cannot('access', 'GlobalSetupPage-defaults-prebidStack')

  const noAccessToRichPlacements: boolean =
    ability.cannot('access', 'Product-richPlacements') ||
    ability.cannot('access', 'GlobalSetupPage-defaults-richPlacements')

  return [
    {
      disabled: noAccessToPrebid,
      element: 'prebid-stack',
      label: tProduct('product.prebidStack'),
      page: noAccessToPrebid ? <NotPurchasedSection /> : <PrebidStackTab />,
    },
    {
      disabled: true,
      element: 'rich-placements',
      label: tProduct('product.richPlacements'),
      page: noAccessToRichPlacements ? <NotPurchasedSection /> : <RichPlacements />,
      section: 'multianchor',
    },
  ]
}
